import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Tabs({ hasHeader }: any) {
    const { useLang, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('delta_pro_ultra.prelaunch');
    const [top, setTop] = useState(0);

    const tabs: any[] = [
        {
            text: t.rich('secA_tab1', {
                n: (text: string) => <span className="no-wrap">{text}</span>,
            }),
            link: '#delta-pro-ultra-prelaunch-C',
            strong: true,
        },
        {
            text: t('secA_tab2'),
            link: '#delta-pro-ultra-prelaunch-B',
        },
        {
            text: t('secA_tab3'),
            link: '#delta-pro-ultra-prelaunch-G',
        },
        {
            text: t('secA_tab4'),
            link: '#delta-pro-ultra-prelaunch-E',
        },
        {
            text: t('secA_tab5'),
            link: '#delta-pro-ultra-prelaunch-H',
        },
    ];
    const [activeTab, setActiveTab] = useState(tabs[0].link);

    const handleChangeTab = (tab: any) => {
        setActiveTab(tab?.link);
        const target = document.querySelector('.delta-pro-ultra-prelaunch .tabs-inner') as HTMLUListElement;
        if (window.innerWidth < target?.offsetWidth) {
            if (['#delta-pro-ultra-prelaunch-B', '#delta-pro-ultra-prelaunch-C'].includes(tab?.link)) {
                target.style.left = '0';
            }
            if (['#delta-pro-ultra-prelaunch-E', '#delta-pro-ultra-prelaunch-G', '#delta-pro-ultra-prelaunch-H'].includes(tab?.link)) {
                target.style.left = `${window.innerWidth - target.offsetWidth}px`;
            }
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                list_name: 'none',
                button_name: tab?.text,
            });
        } catch (e) {
            console.error(e);
        }
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const enterFunc = (id: string) => {
                const target = document.querySelector(id) as HTMLElement;
                const winH = window.innerHeight;
                if (target) {
                    AniContainer.create({
                        triggerElement: target,
                        triggerHook: 1,
                        offset: '50%',
                        duration: target?.offsetHeight - winH / 2,
                        onEnter: () => setActiveTab(id),
                    });
                }
            };
            const idsArr: string[] = [
                '#delta-pro-ultra-prelaunch-B',
                '#delta-pro-ultra-prelaunch-C',
                '#delta-pro-ultra-prelaunch-E',
                '#delta-pro-ultra-prelaunch-G',
                '#delta-pro-ultra-prelaunch-H',
            ];

            idsArr.map((id: string) => enterFunc(id));
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => {
                if (!hasHeader) {
                    setTop(0);
                } else {
                    const announceBar = document.querySelector('.announcement-bar') as HTMLElement;
                    if (announceBar) {
                        const styles = window.getComputedStyle(announceBar);
                        const position = styles.position;
                        if (announceBar && position === 'sticky') {
                            setTop(announceBar?.offsetHeight);
                        }
                    }
                }
            };
            resize();

            window.addEventListener('resize', resize);
            return () => window.removeEventListener('resize', resize);
        }
    }, [hasHeader]);

    return (
        <div className={`tabs ${css['tabs']}`} style={{ top: `${top}px` }}>
            <ul className="tabs-inner" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                {tabs?.map((tab: any, k: number) => (
                    <li
                        className={`tab ${tab?.strong ? 'strong' : ''} ${activeTab === tab?.link ? 'active' : ''}`}
                        key={k}
                        onClick={() => handleChangeTab(tab)}
                    >
                        <a href={tab?.link} className="tab-link">
                            {tab?.text}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}
